import { render } from "./TaskDatasetAndDestinationCard.vue?vue&type=template&id=d8bf81c6&scoped=true"
import script from "./TaskDatasetAndDestinationCard.vue?vue&type=script&lang=js"
export * from "./TaskDatasetAndDestinationCard.vue?vue&type=script&lang=js"

import "./TaskDatasetAndDestinationCard.vue?vue&type=style&index=0&id=d8bf81c6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8bf81c6"]])

export default __exports__